export default __webpack_public_path__ + "static/media/Baking.9ebad3b8.jpg";